var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._l((_vm.images),function(image){return _c('div',{key:image.id,staticClass:"image-item",on:{"click":function($event){return _vm.showImage(image)}}},[_c('img',{attrs:{"src":image.src,"alt":""}}),_c('p',[_vm._v(_vm._s(image.id))])])}),(_vm.isShow)?_c('div',[_vm._v("暂无上传图片")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }